import { render } from "./Galleries.vue?vue&type=template&id=05320d94&scoped=true"
import script from "./Galleries.vue?vue&type=script&lang=js"
export * from "./Galleries.vue?vue&type=script&lang=js"

import "./Galleries.vue?vue&type=style&index=0&id=05320d94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05320d94"]])

export default __exports__